import * as constants from 'actions/constants'
import { EntryType } from 'actions/general';
import { PublicProfile } from 'types/publicProfile';
import { Profile } from 'types/user'

export interface ProfileReducer {
  profile: Profile | null;
  status: string | null;
  loading: boolean
  publicProfiles: Map<string, PublicProfile>;
}
const defaultState: ProfileReducer = {
  profile: null,
  status: null,
  loading: false,
  publicProfiles: new Map<string, PublicProfile>()
}

let profileObject: any = {} //FOR EDITING

export default function profile(state = defaultState, action: any) {
  switch (action.type) {
    case constants.GET_MY_PROFILE_TRY:
      return Object.assign({}, state, {
        loading: true
      })
    case constants.GET_MY_PROFILE_RESPONSE:
      if (action.response.success) {
        return Object.assign({}, state, {
          profile: action.response.profile,
          status: action.response.status,
          loading: false
        })
      }
      return Object.assign({}, state, {
        loading: false,
      })

    case constants.GET_MY_PROFILE_ERROR:
      return Object.assign({}, state, {
        loading: false,
      })

    case constants.GET_PUBLIC_PROFILES_RESPONSE:
      if (action.response.success) {
        const publicProfiles = state.publicProfiles instanceof Map ? new Map<string, PublicProfile>(state.publicProfiles) : new Map<string, PublicProfile>()
        action.response.profiles?.forEach((profile: PublicProfile) => {
          publicProfiles.set(profile.id, profile)
        })
        return Object.assign({}, state, { publicProfiles })
      }

    case constants.ADD_IMAGE_LINK_TO_PROFILE_RESPONSE:
      if (action.response.success) {
        profileObject = Object.assign({}, state.profile, {
          image: action.image,
        })
        return Object.assign({}, state, { profile: profileObject })
      }

    case constants.UPDATE_MY_INTERESTS_RESPONSE:
      if (action.response.success) {
        profileObject = Object.assign({}, state.profile, {
          interests: action.interests,
        })
        return Object.assign({}, state, { publicProfiles: profileObject })
      }

    case constants.GET_PUBLIC_PROFILE_RESPONSE:
      if (!action.response.success) return state
      const ps = state.publicProfiles instanceof Map ? new Map(state.publicProfiles) : new Map();
      if (!action.response.profile){
        return state
      }
      ps.set(action.response.profile.id, action.response.profile)
      return Object.assign({}, state, { publicProfiles: ps })

    case constants.CLEAR_OLD_DATA:
      if (action.force && action.entryType === EntryType.PROFILE) return Object.assign({}, state, { publicProfiles: new Map() })
      return state


    case constants.GET_PUBLIC_PROFILES_RESPONSE:
      if (action.response.success) {
        const ps = state.publicProfiles instanceof Map ? state.publicProfiles : new Map();
        for (const profile of action.response.profiles) {
          ps.set(profile.id, profile)
        }
        return Object.assign({}, state, { publicProfiles: ps })
      }

    case constants.GET_LATEST_PUBLIC_PROFILES_RESPONSE:
      if (action.response.success) {
        const ps = state.publicProfiles instanceof Map ? state.publicProfiles : new Map();
        for (const profile of action.response.profiles) {
          ps.set(profile.id, profile)
        }
        return Object.assign({}, state, { publicProfiles: ps })
      }
    // if (action.response.success)
    //   return Object.assign({}, state, { latestProfiles: action.response.latestProfiles })

    case constants.LOGOUT_RESPONSE:
      return defaultState

    default:
      if (action?.response?.code === 'FORCE_LOGOUT_FRONTEND') return defaultState
      return state
  }
}
